import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./ContactUS.css";

const ContactUs = () => {
  const [rtl, setRtl] = useState(localStorage.getItem("Language") == "rtl");
  const [fr, setFr] = useState(localStorage.getItem("Language") == "fr");
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    message: "",
  });

  const handleForm = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    var rtl = document.querySelector("body").getAttribute("class");

    if (rtl) {
      if (rtl.includes("rtl")) {
        setRtl(true);
      } else {
        setRtl(false);
      }
    }
  }, []);

  return (
    <div id="">
      <div id="">
        <div className="wrapper" id="cover">
          <img
            src={require("../../Assets/images/contact-us-overlay.jpg")}
            className="prx"
            style={{ height: "205px", width: "100%" }}
          />
          <h1>{rtl ? `اتصل بنا` : fr ? "NOUS CONTACTER" : `Contact Us`}</h1>
        </div>
      </div>

      <div id="bodycontt" class="bg">
        <div className="pagewrap">
          <div className="wrapper grid5">
            <article
              className="fluid animated fadeInRight"
              style={{ width: "19%" }}
            >
              <div className="col">
                <div className="sidelight white">
                  <h5>
                    {" "}
                    {rtl
                      ? "وظائف مكة والمدينة القابضة المحدودة"
                      : fr
                      ? "CARRIÈRES MMH"
                      : "MMH Careers"}
                  </h5>
                  <img
                    src={require("../../Assets/images/makkah.jpg")}
                    className="crv2"
                  />
                  <p>
                    {rtl
                      ? `تقدم وظائف مكة والمدينة القابضة المحدودة
 فرصا وظيفية مثيرة في جميع أنحاء العالم.
`
                      : fr
                      ? `Mecque & La Médine offre des opportunités
                       de carrière passionnantes dans le monde entier.`
                      : `Makkah & Al Madina Holding offers
                                        exciting career opportunities across the
                                        world.`}
                  </p>
                  <p>&nbsp;</p>
                  <Link to="/careers">
                    <p className="button2">
                      {rtl ? "التعرف على المزيد" : "Learn More"}
                    </p>
                  </Link>
                </div>
              </div>
            </article>
            <article className="fluid two animated fadeInDown contact">
              <div className="col">
                <h1>
                  {rtl ? `اتصل بنا` : fr ? "Nous Contacter" : `Contact Us`}
                </h1>
                <p>
                  {rtl
                    ? `للاتصال بنا عبر البريد الإلكتروني ، ما عليك سوى ملء النموذج أدناه.
`
                    : fr
                    ? `Pour nous contacter par email, il vous suffit
                    de remplir le formulaire ci-dessous.`
                    : `To contact us by email, simply fill in the
                                    form below.`}
                </p>
                <br />
                <form id="contactform">
                  <div className="form">
                    <label>
                      <p>
                        {rtl
                          ? `اسم و اللقب:
`
                          : fr
                          ? "Nom :"
                          : `Name :`}
                      </p>
                    </label>
                    <input
                      type="text"
                      size="30"
                      name="name"
                      id="contactname"
                      value={form.name}
                      onChange={handleForm}
                      className="required"
                    />
                  </div>
                  <div className="form">
                    <label>
                      <p>
                        {rtl
                          ? `البريد الإلكتروني:`
                          : fr
                          ? "Courriel :"
                          : `Email :`}
                      </p>
                    </label>
                    <input
                      type="text"
                      size="30"
                      name="email"
                      id="email"
                      value={form.email}
                      onChange={handleForm}
                      className="required email"
                    />
                  </div>
                  <div className="form">
                    <label>
                      <p>{rtl ? `جوال:` : fr ? "Mobile :" : `Mobile :`}</p>
                    </label>
                    <input
                      name="mobile"
                      value={form.mobile}
                      onChange={handleForm}
                      type="text"
                      size="30"
                    />
                  </div>

                  <div className="form">
                    <label>
                      <p>{rtl ? `رسالة:` : fr ? "Message :" : `Message :`}</p>
                    </label>
                    <textarea
                      rows="5"
                      cols="30"
                      name="message"
                      id="message"
                      value={form.message}
                      onChange={handleForm}
                      className="required"
                    ></textarea>
                  </div>
                  <input
                    type="submit"
                    value={rtl ? `إرسال` : fr ? "Envoyer" : "Submit"}
                    name="submit"
                    className="insub"
                  />
                </form>
                <p>&nbsp;</p>
                <p>&nbsp;</p>

                <iframe
                  width="640"
                  height="380"
                  id="gmap_canvas"
                  src="https://maps.google.com/maps?q=71-75%20Shelton%20Street,%20Covent%20Garden,%20London,%20WC2H%209JQ.%20&t=&z=13&ie=UTF8&iwloc=&output=embed"
                  frameborder="0"
                  scrolling="no"
                  marginheight="0"
                  marginwidth="0"
                ></iframe>
                <p>&nbsp;</p>
                <p>&nbsp;</p>
                <div className="addthis_native_toolbox"></div>
              </div>
            </article>
            <article
              className="fluid animated fadeInLeft"
              style={{ width: "21%" }}
            >
              <div className="col">
                <h3>
                  {rtl
                    ? `معلومات الاتصال`
                    : fr
                    ? "Info Contact"
                    : `Contact Info`}
                </h3>
                <div className="right-box">
                  <img
                    src={require("../../Assets/images/company.jpg")}
                    className="crv2"
                  />
                  <p>
                    <span>
                      {rtl
                        ? `المكتب الرئيسي`
                        : fr
                        ? "Siège Sociale"
                        : `Head Office`}
                    </span>
                  </p>
                  <p>
                    {rtl
                      ? `71-75 شارع شيلتون`
                      : fr
                      ? `71-75 Shelton Street`
                      : `71-75 Shelton Street`}
                  </p>
                  <p>
                    {rtl
                      ? `كوفنت جاردن, لندن, المملكة المتحدة WC2H 9JQ`
                      : fr
                      ? ` Covent Garden, Londres,
                      Royaume-Uni WC2H 9JQ`
                      : ` Covent Garden, London, United Kingdom
                                        WC2H 9JQ`}
                  </p>
                  <p>
                    {rtl
                      ? `الهاتف: +44 (020) 8099-8978`
                      : fr
                      ? "Tél: +44 (020) 8099-8978"
                      : `Tel: +44 (020) 8099-8978`}
                  </p>
                  <p>&nbsp;</p>
                  <p>
                    <span>
                      {rtl ? `البريد الإلكتروني` : fr ? "Courriel" : `Email`}
                    </span>
                  </p>
                  <p>info@makkahalmadinah.com</p>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
